import $ from 'jquery';
import 'slick-carousel';

export default function initM77() {
    $(function () {
        if ($('.module-m77').length > 0) {
            $('.module-m77').each(function () {
                let $module = $(this);
                $module.find('.module-m77-items').slick({
                    arrows: false,
                    dots: true,
                    // waitForAnimate: false,
                    appendDots: $module.find('.module-m77-items-dots'),
                    //    mobileFirst: true,
                    //    responsive: [
                    //     {
                    //         breakpoint: 767,
                    //         settings: 'unslicl'
                    //     }
                    //    ]
                });
            });
        }

    });
}
